import { makeStyles } from 'tss-react/mui';

const useStylesNoContentBlock: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  noContentBlock: {
    padding: '15px 20px',
  },
  noContentBlockExtended: {
    padding: '20px 35px',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 15px',
    },
  },
}));

export default useStylesNoContentBlock;
